<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Integration</div>
        <div>
          <bread-crumb :bread-crumbs="['Integration']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-row class="mt-1">
          <v-col cols="12" md="2" lg="3" xs="12">
            <v-autocomplete
              :items="Payoutpartners"
              v-model="parent_payout_partner_id"
              item-text="name"
              item-value="id"
              outlined
              dense
              placeholder="Payout partner"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="2" lg="2" xs="12">
            <v-text-field
              v-model="txn_pin"
              dense
              placeholder="Pin number"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2" lg="2" xs="12">
            <v-text-field
              type="date"
              v-model="from_date"
              :max="maxDate"
              :rules="[validateFromDate]"
              :items="integrationLogs"
              label="From"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2" lg="2" xs="12">
            <v-text-field
              type="date"
              label="To"
              v-model="to_date"
              :items="integrationLogs"
              :rules="[validateToDate]"
              :max="maxDate"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <div class="d-flex">
            <v-btn
              depressed
              small
              class="text-capitalize"
              color="primary"
              @click="getIntegrationlogdata()"
              >Get Results</v-btn
            >
          </div>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4" lg="4" xs="12"
            ><v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to search the table data."
              hide-details
              single-line
              class="me-4"
              dense
              clearable
            ></v-text-field
          ></v-col>
        </v-row>
        <v-data-table
          fixed-header
          height="55vh"
          class="mt-6"
          :headers="headers"
          :items="integrationLogs"
          :items-per-page="10"
          dense
          loading-text="Please select the criteria to view records."
          no-data-text="Please select the criteria to view records."
        >
          <template v-slot:item.token_payload="{ item }">
            <v-icon
              small
              color="primary"
              title="Click to Download Log"
              class="mr-2"
              @click="downloaditem(item)"
            >
              mdi-download
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
      <OverlayPageVue :showOverlay="loaderOverlay" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import downloadFile from "@/utils/ExportTxt/downloadfile.js";
import commonService from "@/services/CommonService/commonService.js";
import partnerService from "@/services/partnerService/partnerService.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name: "Integration",
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  data: () => ({
    downloadFile,
    headers: [
      { text: "ID", value: "_id", width: "100" },
      {
        text: "Api Route Uri",
        value: "api_route_uri",
        align: "start",
        width: "200",
      },
      {
        text: "Api Route Method",
        value: "api_route_method",
      },
      {
        text: "Token Payload",
        value: "token_payload",
      },
      {
        text: "Function Involved ",
        value: "functions_involved",
      },
      {
        text: "Start Timestamp",
        value: "start_timestamp",
      },
    ],
    integrationLogs: [],
    Payoutpartners: [],
    loaderOverlay: false,
    search: "",
    parent_payout_partner_id: null,
    txn_pin: null,
    from_date: null,
    to_date: null,
  }),
  computed: {
    maxDate() {
      // get current date and format as YYYY-MM-DD for use with max attribute
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      return `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;
    },
  },
  mounted() {
    this.getpayoutpartners();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    validateFromDate(value) {
      if (value && this.to_date) {
        return (
          value <= this.to_date || "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToDate(value) {
      if (value && this.from_date) {
        return (
          value >= this.from_date || "To date cannot be earlier than From date"
        );
      }
      return true;
    },
    async downloaditem(item) {
      this.downloadFile(item);
    },
    async getpayoutpartners() {
      try {
        const responseData = await partnerService.getMainRecList();
        if (responseData.data.status_code === 200) {
          this.Payoutpartners = responseData.data.data.map((i) => {
            return { name: i.partner_name, id: i.partner_id };
          });
        }

        console.log("getEndpointValues", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getIntegrationlogdata() {
      this.loaderOverlay = true;
      try {
        const params = {
          parent_payout_partner_id: this.parent_payout_partner_id,
          txn_pin: this.txn_pin,
          from_date: this.from_date,
          to_date: this.to_date,
          skip: 0,
          limit: 50,
        };
        const response = await commonService.getIntegrationlog(params);
        if (response.status === 200) {
          this.integrationLogs = response.data.data;
          console.log("integrationLogs", this.integrationLogs);
          this.stoploader();
        } else {
          this.integrationLogs == [];
          this.stoploader();
        }
      } catch (error) {
        this.integrationLogs = [];
        this.stoploader();
        console.error(error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
</style>
